import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlockItem } from '@cbridge-tools/navigation-block';
import { PolicyProtection } from '@cbridge-packages/auth';
import { isMatchedPathnameSelector } from '@cbridge-packages/routing';
import { MarkupProfileContextMenu } from '../contextMenu/MarkupProfileContextMenu';
import { IMarkupProfileItemProps } from './MarkupProfileItem.interface';

export const MarkupProfileItem: FunctionComponent<IMarkupProfileItemProps> = ({ item }) => {
  const { label, href } = item;

  const isSelected = useSelector(isMatchedPathnameSelector, { pattern: href });

  return (
    <NavigationBlockItem
      label={label}
      href={href}
      hoverAction={
        <PolicyProtection>
          <MarkupProfileContextMenu item={item} />
        </PolicyProtection>}
      isSelected={isSelected}
    />
  );
};
